export function preview(file, width, height) {
  return resize(file, width, height);
}

export const handleImgLoad = (file, img, maxWidth, maxHeight, resolve) => {
  let imgWidth = img.width;
  let imgHeight = img.height;
  if (imgWidth < maxWidth && imgHeight < maxHeight) {
    // No need to resize if the image is within the limits
    resolve(file);
  }
  if (imgWidth > imgHeight) {
    imgHeight = Math.round(imgHeight * (maxWidth / imgWidth));
    imgWidth = maxWidth;
  } else {
    imgWidth = Math.round(imgWidth * (maxHeight / imgHeight));
    imgHeight = maxHeight;
  }
  const canvas = document.createElement('CANVAS');
  canvas.width = imgWidth;
  canvas.height = imgHeight;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, imgWidth, imgHeight);
  canvas.toBlob(
    (resizedImage) => resolve(resizedImage),
    file.type,
    0.9,
  );
};

// Allowed image MIME types for security validation
const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/bmp'];

export function resize(file, maxWidth = 1280, maxHeight = 1280) {
  return new Promise((resolve, reject) => {
    // Validate file type before processing to prevent XSS via malicious files
    if (!file || !file.type || !ALLOWED_IMAGE_TYPES.includes(file.type)) {
      reject(new Error('Invalid image file type'));
      return;
    }

    /* eslint-disable-next-line no-undef */
    const apiUrl = (window.createObjectURL && window) || (window.URL && URL.createObjectURL && URL) || (window.webkitURL && webkitURL);
    const img = document.createElement('IMG');
    const objectUrl = apiUrl.createObjectURL(file);

    img.onload = () => {
      apiUrl.revokeObjectURL(objectUrl); // Clean up for memory + Veracode
      handleImgLoad(file, img, maxWidth, maxHeight, resolve);
    };

    img.onerror = () => {
      apiUrl.revokeObjectURL(objectUrl); // Still clean up even on error
      reject(new Error('Failed to load image'));
    };

    // Parse and validate blob URL via URL constructor to sanitize for CWE-80
    let sanitizedSrc;
    try {
      const parsedUrl = new URL(objectUrl);
      if (parsedUrl.protocol !== 'blob:') {
        throw new Error('Not a blob URL');
      }
      sanitizedSrc = parsedUrl.href;
    } catch (e) {
      apiUrl.revokeObjectURL(objectUrl);
      reject(new Error('Invalid object URL'));
      return;
    }
    img.src = encodeURI(sanitizedSrc);
  });
}
